import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

export const CheckBorder = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.background};
  border: 1px solid ${(props) => props.theme.keyline};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const Label = styled.label`
  font-size: 16px;
  color: ${(props) => props.theme.textDark};
  margin-left: 10px;
`;

export const HiddenInput = styled.input`
  width: 100%;
  height: 100%;
  opacity: 0;
  position: absolute;
  z-index: 2;
`;
